import { Injectable } from '@angular/core';
import { DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';
import { ClaimService } from '@lsq-frontend/common-ui';
import { map } from 'rxjs/operators';
import { WhiteLabelRule } from '../white-label-rule';

@Injectable()
export class FactoringWhiteLabelRule implements WhiteLabelRule {
    public whiteLabelRule$ = this._claimService.isOn(DashboardClaim.FactoringDashboard).pipe(
        map((isFactoringUser) =>
            isFactoringUser
                ? {
                      scfPlatformProductName: undefined,
                      scfPlatformPlatformName: undefined,
                      navbarMainBrandLogoIconConfig: undefined,
                      navbarCoBrandLogoAssetPath: undefined
                  }
                : {}
        )
    );

    constructor(private _claimService: ClaimService) {}
}
